(function () {
  function initSection(section) {
    if (!section || section.dataset.valvinPlpBound === 'true') return;

    section.dataset.valvinPlpBound = 'true';

    var header = document.querySelector('.section-header');
    var drawer = section.querySelector('.sidebar');
    var backdrop = section.querySelector('[data-valvin-filters-backdrop]');
    var openButton = section.querySelector('[data-valvin-filter-open]');
    var closeButton = section.querySelector('[data-valvin-filter-close]');
    var filterForm = section.querySelector('.valvin-filter-form');
    var sortSelect = section.querySelector('[data-valvin-sort-select]');
    var toggleButtons = section.querySelectorAll('[data-valvin-filter-toggle]');
    var descriptionBlocks = Array.from(section.querySelectorAll('[data-valvin-description]'));
    var headerScrolledState = header ? header.classList.contains('scrolled-past-header') : false;
    var layoutTicking = false;

    function getHeaderHeight() {
      var rawHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      var headerHeight = parseFloat(rawHeight);

      return Number.isNaN(headerHeight) ? 0 : headerHeight;
    }

    function getCollapsedDescriptionHeight(content) {
      var compactLimit = window.matchMedia('(max-width: 780px)').matches ? 128 : 152;
      var minimumReadableHeight = window.matchMedia('(max-width: 780px)').matches ? 88 : 104;
      var childElements = Array.from(content.children).filter(function (child) {
        return child.offsetHeight > 0;
      });
      var bestHeight = 0;

      childElements.forEach(function (child) {
        var childBottom = child.offsetTop + child.offsetHeight;

        if (childBottom <= compactLimit + 4) {
          bestHeight = childBottom;
        }
      });

      if (bestHeight >= minimumReadableHeight) {
        return bestHeight;
      }

      return Math.min(content.scrollHeight, compactLimit);
    }

    function updateDesktopSidebarMode() {
      var availableHeight;
      var sidebarHeight;

      if (!drawer) return;

      drawer.classList.remove('sidebar--desktop-sticky');

      if (!window.matchMedia('(min-width: 781px)').matches) return;

      availableHeight = window.innerHeight - getHeaderHeight() - 16;
      sidebarHeight = drawer.offsetHeight;

      if (sidebarHeight <= availableHeight) {
        drawer.classList.add('sidebar--desktop-sticky');
      }
    }

    function updateDescriptionStates() {
      descriptionBlocks.forEach(function (block) {
        var content = block.querySelector('[data-valvin-description-content]');
        var toggle = block.querySelector('[data-valvin-description-toggle]');
        var collapsedHeight;
        var isOverflowing;
        var userExpanded = block.dataset.valvinDescriptionExpanded === 'true';
        var toggleLabel = userExpanded ? 'Show less' : 'Show more';

        if (!content || !toggle) return;

        block.classList.remove('is-collapsible');
        block.classList.remove('is-expanded');
        block.style.removeProperty('--collection-description-collapsed-height');
        toggle.hidden = true;
        toggle.textContent = toggleLabel;
        toggle.setAttribute('aria-expanded', userExpanded ? 'true' : 'false');

        collapsedHeight = getCollapsedDescriptionHeight(content);
        isOverflowing = content.scrollHeight - collapsedHeight > 12;

        if (!isOverflowing) return;

        block.style.setProperty('--collection-description-collapsed-height', collapsedHeight + 'px');
        block.classList.add('is-collapsible');
        toggle.hidden = false;

        if (userExpanded) {
          block.classList.add('is-expanded');
        }
      });
    }

    function queueLayoutUpdate() {
      if (layoutTicking) return;

      layoutTicking = true;
      window.requestAnimationFrame(function () {
        layoutTicking = false;
        updateDesktopSidebarMode();
        updateDescriptionStates();
      });
    }

    function realignCollapsedDescription(block) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          var targetTop = Math.max(0, block.getBoundingClientRect().top + window.scrollY - getHeaderHeight() - 16);
          var visibleTop = block.getBoundingClientRect().top;
          var shouldScroll = window.scrollY > targetTop + 8 || visibleTop < getHeaderHeight() + 12;

          if (!shouldScroll) return;

          window.scrollTo({
            top: targetTop,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        });
      });
    }

    function runSettledMeasurements() {
      queueLayoutUpdate();

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(queueLayoutUpdate);
      });

      window.setTimeout(queueLayoutUpdate, 120);
    }

    function handleHeaderClassChange() {
      var nextScrolledState;

      if (!header) return;

      nextScrolledState = header.classList.contains('scrolled-past-header');

      if (nextScrolledState === headerScrolledState) return;

      headerScrolledState = nextScrolledState;
      runSettledMeasurements();
    }

    function handleHeaderTransitionEnd(event) {
      if (
        event.propertyName !== 'max-height' ||
        !event.target ||
        (!event.target.classList.contains('valvin-header__utility-row') &&
          !event.target.classList.contains('valvin-service-strip'))
      ) {
        return;
      }

      runSettledMeasurements();
    }

    function closeDrawer() {
      section.classList.remove('is-filters-open');
    }

    function openDrawer() {
      var firstField;

      if (!drawer) return;

      if (window.matchMedia('(max-width: 780px)').matches) {
        section.classList.add('is-filters-open');
        firstField = drawer.querySelector('input, button, select, a');
        if (firstField) firstField.focus();
        return;
      }

      window.scrollTo({
        top: Math.max(0, drawer.getBoundingClientRect().top + window.scrollY - getHeaderHeight() - 16),
        behavior: 'smooth',
      });
    }

    if (openButton) {
      openButton.addEventListener('click', openDrawer);
    }

    if (closeButton) {
      closeButton.addEventListener('click', closeDrawer);
    }

    if (backdrop) {
      backdrop.addEventListener('click', closeDrawer);
    }

    toggleButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var body = button.nextElementSibling;
        var icon = button.querySelector('.filter-chevron');

        if (!body) return;

        body.classList.toggle('is-collapsed');
        if (icon) {
          icon.textContent = body.classList.contains('is-collapsed') ? '+' : '-';
        }
        queueLayoutUpdate();
      });
    });

    descriptionBlocks.forEach(function (block) {
      var toggle = block.querySelector('[data-valvin-description-toggle]');

      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var nextExpanded = block.dataset.valvinDescriptionExpanded !== 'true';

        block.dataset.valvinDescriptionExpanded = nextExpanded ? 'true' : 'false';
        block.classList.toggle('is-expanded', nextExpanded);
        toggle.textContent = nextExpanded ? 'Show less' : 'Show more';
        toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
        queueLayoutUpdate();

        if (!nextExpanded) {
          realignCollapsedDescription(block);
        }
      });
    });

    if (filterForm) {
      filterForm.addEventListener('change', function (event) {
        if (!event.target || event.target.type !== 'checkbox') return;
        filterForm.submit();
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        sortSelect.form.submit();
      });
    }

    if (drawer && 'ResizeObserver' in window) {
      new ResizeObserver(queueLayoutUpdate).observe(drawer);
    }

    if (header && 'MutationObserver' in window) {
      new MutationObserver(handleHeaderClassChange).observe(header, {
        attributes: true,
        attributeFilter: ['class'],
      });

      header.addEventListener('transitionend', handleHeaderTransitionEnd);
    }

    window.addEventListener('resize', queueLayoutUpdate);
    window.addEventListener('load', runSettledMeasurements);
    window.addEventListener('pageshow', runSettledMeasurements);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(runSettledMeasurements);
    }

    runSettledMeasurements();
  }

  function initSections(root) {
    var scope = root || document;
    var sections = [];

    if (scope.matches && scope.matches('.valvin-plp')) {
      sections.push(scope);
    }

    if (scope.querySelectorAll) {
      sections = sections.concat(Array.from(scope.querySelectorAll('.valvin-plp')));
    }

    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSections(document);
    });
  } else {
    initSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSections(event.target);
  });
})();
